import {
  ButtonBase,
  CardContent,
  CardHeader,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import Loading from 'components/Loading';
import { cyrb53Hash } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface FooterProps {
  name: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  link?: string;
  onClick?: () => void;
}

export interface ExhibitionCardProps {
  title?: string;
  type?: string;
  value?: any;
  contentImg?: React.ReactNode;
  footer?: FooterProps[];
  hasType?: boolean;
  loading?: boolean;
}

const ExhibitionCard = ({
  title,
  value,
  footer,
  contentImg,
  type,
  hasType,
  loading = false,
}: ExhibitionCardProps) => {
  const classes = useStyles();

  return (
    <Paper
      elevation={2}
      className={classes.container}
      data-testid={'autosky-exhibition-card'}
    >
      <Grid item xs={12} className={classes.headerContent}>
        <CardHeader
          title={title}
          subheader={hasType && type}
          className={classes.header}
        />
      </Grid>
      {loading ? (
        <Grid
          container
          alignItems="center"
          justify="center"
          className={classes.loadingContent}
        >
          <Loading />
        </Grid>
      ) : (
        <>
          <CardContent className={classes.content}>
            {typeof value === 'string' && (
              <Typography variant="h4" component="h2" className={classes.value}>
                {value}
              </Typography>
            )}
            {contentImg && <>{contentImg}</>}
          </CardContent>
        </>
      )}
      {footer && (
        <CardActions className={classes.footer}>
          {footer.map(item => (
            <ButtonBase
              onClick={item?.onClick}
              disabled={item?.disabled}
              key={cyrb53Hash(item.name)}
            >
              {item.icon}
              <Typography className={classes.footerName}>
                {item.name}
              </Typography>
            </ButtonBase>
          ))}
        </CardActions>
      )}
    </Paper>
  );
};

export default ExhibitionCard;
